import { Modal, Form, Button } from 'react-bootstrap';
import { useRef, useEffect, useState } from 'react';
import Recaptcha from '@components/general/Recaptcha';
import { Request } from '@group-devs/yfp7-global-modules'
import Authenticator from '@group-devs/yfp7-authenticator'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { useRouter } from 'next/router'

const request = new Request(process.env.apiDomain)
const axiosapi = require('../../pages/api/AxiosApi.js');

function ArticleJoinForm(props) {

    const captchaRef = useRef(null)
    
    const router = useRouter()
    const currentUrl = router.asPath

    let curProps = currentUrl && currentUrl == "/file-cabinet" ? props.props.props.props.props : props.props.props.props.props.props
    

    let site = curProps.site
    let metadata = curProps.metadata
    const { data: ownerAccount } = request.account.swrAccountProfile(site ? site.accountId : '')
    const { data: hub } = request.website.swrSite(site ? site.accountId : '', "HUB")

    let defaultCountryCode = curProps.defaultCountryCode
    defaultCountryCode = Object.values(defaultCountryCode.map(item => (
        item.alpha2.toLowerCase()
    )));

    const [errorMessage, setErrorMessage] = useState('')
    const [errorRecaptcha, setErrorRecaptcha] = useState("google-captcha")
    const [validationUrl, setUrl] = useState('')
    const [loginUrl, setLoginUrl] = useState('')
    const [isLogin, setIsLogin] = useState(false)
    const [verified, setVerified] = useState(false)
    const [password_verified, setPasswordVerified] = useState(false)
    const [redirectUrl,setRedirectUrl] = useState('')

    const [data, setData] = useState({
      firstname: '',  
      lastname: '',
      email: '',
      phone_number: '',
      password: '',
      confirm_password: '',
      country_code: ''
    })

    const [errorMsg, setErrorMsg] = useState({
      firstname: '',  
      lastname: '',
      email: '',
      phone_number: '',
      password: '',
      confirm_password: '',
      country_code: ''
    })
    
     const handleChange = (evt) => {
      const value = evt.target.value
      setData({
        ...data,
        [evt.target.name]: value
      })
    }

    const restrictNumbers = (evt) => {
      const value = evt.target.value
      let result = value.replace(/[^a-z ]/gi, '');
      result = result.replace(/\s+/g, " ");

      setData({
        ...data,
        [evt.target.name]: result
      })
    }

    const isValidEmail = async (evt) => {
      const validEmail = /\S+@\S+\.\S+/.test(evt.target.value);
      const email = evt.target.value;
      if (!validEmail) {
        setErrorMsg({
          ...errorMsg,
          [evt.target.name]: 'Email is invalid'
        });
      }
      else{
        var emailExist = await onCheckEmail(email);
        if(emailExist)
        {
          setErrorMsg({
            ...errorMsg,
            [evt.target.name]: 'Email already exist!'
          });
        }
        else
        {
          setErrorMsg({
            ...errorMsg,
            [evt.target.name]: ''
          });
        }
        
      }
    }

    const checkErrMsgs = () => {
      var err = 0;
      const errList = Object.entries(errorMsg).map(([key,value])=>{
          if (value != null || value != "")
              err++;
      },[err])

      if (err)
          return false;
      else
          return true;
    }

    function fetchResponseErrors(responseErr)
    {
        let errData = {};

        const errList = Object.entries(responseErr).map(([key,value])=>{
            const errField = key.toString();
            const errValue = value.toString();
            var errors = Object.assign({}, errData);
            errors[errField] = errValue;
            errData = errors;
        })
        
        setErrorMsg(errData);
    }

    const checkVerification = verified => {
        setVerified(verified);
    }

    const setCountry = (value, country, e, formattedValue) => {
      setData({
        ...data,
        ['country_code']: country.countryCode,
        ['phone_number']: value.slice(country.dialCode.length)
      })
    }

    function checkPasswordConfirmation(event) {
      const confirm_password = event.target.value
      var errMsg = ""

      if(data.password != "" && data.password !== confirm_password) {
        if(data.password !== confirm_password) {
          errMsg = "Password doesn't match"
        }
      }

      if(data.password == "") {
        errMsg = "Password is empty"
      }
      
      setErrorMsg({
        ...errorMsg,
        [event.target.name]: errMsg
      });
    }

    const verifyPassword = (password, confirm_password) => {
      if (password != "" && confirm_password != ""){
        if (password === confirm_password){
          setPasswordVerified(true)
        }
      }
    }

    async function onCheckEmail(email,req="",res="")
    {
      let _response, axiosApi = new axiosapi(req, res, process.env, process.env.apiDomain)

      _response = await axiosApi.postCheckEmail(email)
      
      return _response.data.contact;
    }

    function checkPassword(event) {
      const password = event.target.value
      var errMsg = ""

      if (data.confirm_password != "") {
        if(password !== data.confirm_password) {
            errMsg = "Password doesn't match"
        }

        setErrorMsg({
          ...errorMsg,
          ['confirm_password']: errMsg
        });
      }
    }

    async function onSubmit (e) {
      e.preventDefault()

      // Clear error message on submit
      setErrorMessage('')

      const checkErrMsg = checkErrMsgs();
      if (verified) {
        setErrorRecaptcha("google-captcha");
        
        const formData = new FormData(e.target),
            formDataObj = Object.fromEntries(formData.entries())

        if (verifyPassword(formDataObj.password, formDataObj.confirm_password)) {
          return false
        }
      
        let newData, post, meta_data, metaDataDetails, loginDetails = {}

        metaDataDetails = {
          code: site.site.code,
          name: site.site.name
        }

        meta_data = Buffer.from(JSON.stringify(metaDataDetails)).toString('base64')

        newData = {
          websiteId: site.websiteId,
          meta_data: meta_data,
          userId: ownerAccount ? ownerAccount.userId : ''
        }

        post = {...formDataObj, ...newData}

        
        loginDetails = {
          email: post.email,
          password: post.password,
          websiteId: site.websiteId,
          domain: hub.url,
          csrf: metadata.csrf,
        }

        function handleSuccess(data) {
          if (data.token === null)
              setErrorMessage(data.message)
          return data
        }

        if (checkErrMsgs) {
          const _response = await fetch(validationUrl, {
            method: 'POST',
            headers: Authenticator.getJSONHeaders(),
            body: JSON.stringify(post)
          })
          .then((response) => { return response.json() })
          .catch(function(error) { console.log(error) })

          // Parse response to object
          let newResponse = JSON.parse(_response);

          if (typeof newResponse === 'object'){
            if (newResponse.code === 200) {
              props.props.props.props.onHide() // Hide Modal
              props.props.props.props.successModal() // Show Success Modal
              const newResponse = await fetch(loginUrl, {
                method: 'POST',
                headers: Authenticator.getJSONHeaders(),
                body: JSON.stringify(loginDetails)
              })
              .then((response) => { return response.json() })
              .then((data) => handleSuccess(data)).catch((error) => {
                  console.log(error)
              })
              
              // Parse response to object
              const autoLoginResponse = JSON.parse(newResponse);

              if (typeof autoLoginResponse === 'object'){
                  if (autoLoginResponse.code === 200) {
                      if (typeof window !== 'undefined') {

                        if(currentUrl && currentUrl == "/file-cabinet"){
                            window.location.reload();
                        }else{
                            window.location.href = redirectUrl
                        }

                      }
                  }
              }
            }else{
              if (typeof newResponse.error === 'string') {
                var errors = newResponse.error
                fetchResponseErrors(JSON.parse(errors));
              }
            }
          }
        }

      }else{
        setErrorRecaptcha("google-captcha error_chk");
      }
    }


    useEffect(() => {
      let url, host, loginurl;
      host = new URL(window.location.href);
      url  = new URL(`${host.protocol}//${host.host}/api/post`);
      url.searchParams.append('action', 'optin')
      setUrl(url)

      loginurl  = new URL(`${host.protocol}//${host.host}/api/authenticate`);
      loginurl.searchParams.append('continue', '/home')
      setLoginUrl(loginurl)

      if (typeof curProps.site !== 'undefined') {
        const IsLogin = curProps.auth.isAuthenticated;
        setIsLogin(IsLogin)
     }

      setRedirectUrl(window.location.href)

    }, [])

  return (
    <div className="section-join-form">
    <div className="text-danger mb-3 h7">{errorMessage}</div>
      <Form onSubmit={onSubmit}>
        <input type="hidden" name="siteFrom" value="wellness"/>
        <Form.Group className="mb-3" controlId="formBasicFName">
          <Form.Control 
            type="text"
            name="firstname"
            placeholder="First Name"
            value={data.firstname}
            onChange={restrictNumbers}
            required
          />
          <Form.Text className="text-danger">{errorMsg.firstname}</Form.Text>
        </Form.Group>
        <Form.Group className="mb-3" controlId="lastname">
          <Form.Control 
            type="text"
            name="lastname"
            placeholder="Last Name"
            value={data.lastname}
            onChange={restrictNumbers}
            required
          />
          <Form.Text className="text-danger">{errorMsg.lastname}</Form.Text>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Control 
            placeholder="Email" 
            type="email"
            name="email"
            value={data.email}
            onChange={handleChange}
            onBlur={isValidEmail}
            required
          />
          <Form.Text className="text-danger">{errorMsg.email}</Form.Text>
        </Form.Group>
        <Form.Group controlId="phoneNumber">
          <PhoneInput
            country={'us'}
            countryCodeEditable = {false}
            onlyCountries={defaultCountryCode}
            preferredCountries={['us']}
            defaultMask={'...-...-....'}
            alwaysDefaultMask={'true'}
            inputStyle={{width:'100%'}}
            inputName="phoneNumber"
            inputProps={{
              name: 'phoneNumber',
              required: true,
              autoFocus: true
            }}
            onChange={setCountry}
          />
        </Form.Group>
        <Form.Group controlId="formBasicNumber">
          <Form.Control type="hidden" name="phone_number" value={data.phone_number} /> 
          <Form.Text className="text-danger">{errorMsg.phone_number}</Form.Text>
        </Form.Group>
        <Form.Group controlId="country_code">
          <Form.Control type="hidden" name="country_code" value={data.country_code} /> 
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Form.Control 
            type="password"
            name="password"
            placeholder="Password"
            value={data.password}
            onChange={handleChange}
            onBlur={checkPassword}
            required
          />
          <Form.Text className="text-danger">{errorMsg.password}</Form.Text>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicConfirmPassword">
          <Form.Control 
            type="password" 
            name="confirm_password"
            placeholder="Confirm Password"
            value={data.confirm_password}
            onChange={handleChange}
            onBlur={checkPasswordConfirmation}
            required
          />
           <Form.Text className="text-danger">{errorMsg.confirm_password}</Form.Text>
        </Form.Group>

        <div className={errorRecaptcha}>
            <Recaptcha checkVerification={checkVerification} />
        </div>

        <Button className="btn-create-account my-3 mx-auto d-block py-2 border-0 rounded-0" variant="primary" type="submit">
          <h4>Create Account</h4>
        </Button>
      </Form>
            
      <style jsx global>{`      

      .section-join-form{
        max-width:455px!important;
      }   

      .section-join-form .form-control{
        font-size:0.9rem;
      }

      .section-join-form .btn-create-account{
        background-color: #43a649!important;
        width:100%;
        max-width:450px;
      }

      .section-join-form .btn-create-account:hover,
      .section-join-form .btn-create-account:active,
      .section-join-form .btn-create-account:focus{
          text-decoration: none;
          background-color: #5ebe64!important;
          border:none!important;
      }
      
      .section-join-form .section-recaptcha > div > div > div > div{
        margin:auto!important;
      }

      `}</style>

    </div>
  );
}

export default ArticleJoinForm;